An array of degrees which were awarded or are being undertaken at the institution.
